import { Box } from "@mui/system"
import { ChargingRulesGlobalComponent } from "layouts/charging-rules/components/ChargingRulesGlobalComponent.tsx"
import { useChargingRulesContext } from "layouts/charging-rules/context/useChargingRulesContext.ts"
import Divider from '@mui/material/Divider';
import { Typography, useMediaQuery } from "@mui/material"

export const ChargingRulesHeader = () => {
    return (
        <Box>
            <Typography
                variant="headlineLarge"
                sx={{ color: "grey.900", mb: "0.5rem" }}
            >
                Règles de recharge d’entreprise
            </Typography>
            <Typography variant="body" sx={{ color: "grey.900" }}>
                Définissez dans cette page les règles de recharge qui
                s'appliqueront par défaut à toutes vos cartes de recharge
                actives.
            </Typography>
        </Box>
    )
}


export const ChargingRulesContainer = () => {
    const { rules } = useChargingRulesContext()
    const isTablet = useMediaQuery('(max-width:900px)');
    return (
        <Box
            sx={{
                gap: "2.5rem",
                display: "flex",
                flexDirection: "column",
                mt: "2rem",
            }}
        >
            {rules.map((rule, index) => (
                <Box key={index}>
                    <ChargingRulesGlobalComponent
                        key={rule.type}
                        rule={rule}
                        isRfid={false}
                    />
                    {isTablet && index < rules.length - 1 && (
                        <Divider  sx={{mt:"1rem"}}/>
                    )}
                </Box>
                  ))}
        </Box>
    )
}
